import React, { useContext, useEffect, useState } from "react";
import {
  Drawer,
  Button,
  Radio,
  Space,
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Upload,
  message,
} from "antd";
import axios from "axios";
import { UploadOutlined, StarOutlined, PlusOutlined } from "@ant-design/icons";
import Compressor from "compressorjs";
import moment from "moment";
import _, { values } from "lodash";
import { authHeader } from "../../../_helpers";
import { CriminalcourtcasesTable } from "../../Wanted/FormsTable/criminalcourtcasesTable";
import { LanguageContext } from "../../../context/LanguageContext";
import { AccusedImageCropModal } from "./AccusedImageCropModal";
import { ImageViewOnly } from "../../image/onlyImageVIew";
// import logo from 'file:///F:/ProfessionalCriminal-WebApp/professionalcriminals-backend/build/uploads/image-1614425782242.png';
const { forwardRef, useRef, useImperativeHandle } = React;
const { Option } = Select;
export const OtherInformation = forwardRef((props, ref) => {
  const baseUrl = `${process.env.REACT_APP_URL}/api`;
  //const baseUrl = 'http://35.154.88.86:8080/api';
  //const baseUrl = 'http://localhost:8080/api';
  const [form] = Form.useForm();
  const [fileList, SetfileList] = useState([]);
  const [phamfileList, SetphamfileList] = useState([]);
  const [tapshilsfile, Settapshilsfile] = useState([]);

  const [imageList_1, SetImageList_1] = useState([]);
  const [imageList_2, SetImageList_2] = useState([]);
  const [docList_1, SetDocList_1] = useState([]);
  const [isImageUploaded, setIsImageUploaded] = useState(false);

  const [isMemberTxt, SetIsMemberTxt] = useState(null);

  const [progress, setProgress] = useState(0);
  const [cropModalVisible, setCropModalVisible] = useState(false);
  const [cropImageSrc, setCropImageSrc] = useState("");
  const [cropOriginalFile, setCropOriginalFile] = useState(null);
  const cropResolveRef = useRef(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const { t } = useContext(LanguageContext);

  const handleUpload = ({ fileList }) => {};

  const handleRemoveAccusedImage = (file) => {
    let temp = fileList;
    let tempIndex = _.findIndex(fileList, file);
    temp && temp.length && temp.splice(tempIndex, 1);
    SetfileList([...temp]);
  };
  const handleRemoveAccusedPham = (file) => {
    let temp = phamfileList;
    let tempIndex = _.findIndex(phamfileList, file);
    temp && temp.length && temp.splice(tempIndex, 1);
    SetphamfileList([...temp]);
  };

  const handleRemoveAccusedRecords = (file) => {
    let temp = tapshilsfile;
    let tempIndex = _.findIndex(tapshilsfile, file);
    temp && temp.length && temp.splice(tempIndex, 1);
    Settapshilsfile([...temp]);
  };

  const handlePreviewAccusedRecords = (file) => {};

  const handlePreviewAccusedImage = (file) => {
    const imageUrl =
      file?.url && file.url.includes(file.name)
        ? file.url
        : file?.name
        ? process.env.REACT_APP_PROFILE_IMAGE_BUCKET_URL + file.name
        : file?.thumbUrl || file?.url;

    if (!imageUrl) {
      message.error("Photo is not available to view.");
      return;
    }

    setPreviewUrl(imageUrl);
    setPreviewOpen(true);
  };

  // const handfileUpload = ({ fileList }) =>{
  //   SetphamfileList( fileList );
  //  }
  //  const tapshilsfileUpload = ({ fileList }) =>{
  //   Settapshilsfile( fileList );
  //  }
  const onFinish = (values) => {
    let accusedImage =
      fileList &&
      fileList.map((item) => {
        return item.name;
      });

    let accusedPham =
      phamfileList &&
      phamfileList.map((item) => {
        return item.name;
      });

    let accusedRecords =
      tapshilsfile &&
      tapshilsfile.map((item) => {
        return item.name;
      });

    values.registered_criminal_cases =
      newMemberList?.length > 0 ? newMemberList : null;
    values.id = props?.otherInformationData[
      props.otherInformationData.length - 1
    ]?.id
      ? props?.otherInformationData[props.otherInformationData.length - 1]?.id
      : "";
    console.log("final values", values);
    const lastOtherInfo =
      props?.otherInformationData?.[props.otherInformationData.length - 1] ||
      {};
    if (isImageUploaded && !lastOtherInfo?.accusedImage) {
      values.photoCreateAt = moment();
      values.photoUpdateAt = moment();
    }

    // ✅ ONLY update upload → update updateAt
    if (isImageUploaded && lastOtherInfo?.accusedImage) {
      values.photoUpdateAt = moment();
    }

    let obj = {
      ...values,
      accusedImage: accusedImage,
      accusedPham: accusedPham,
      accusedRecords: accusedRecords,
    };

    props.otherInformationFiniesh(obj);
    // props.otherInformationFiniesh(values);
    // form.resetFields();
  };

  function beforeUpload(file) {
    return new Promise((resolve, reject) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";

      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
        return reject(false);
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("Image size must be less than 2MB!");
        return reject(false);
      }

      // 🔥 Magic number validation
      const reader = new FileReader();
      reader.onloadend = function (e) {
        const arr = new Uint8Array(e.target.result).subarray(0, 4);
        let header = "";
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }

        const isJPEG = header.startsWith("ffd8ff");
        const isPNG = header === "89504e47";

        if (!isJPEG && !isPNG) {
          message.error("Invalid image file! Possible malicious file.");
          return reject(false);
        }

        resolve(true);
      };

      reader.readAsArrayBuffer(file.slice(0, 4));
    });
  }

  const closeCropModal = () => {
    if (cropImageSrc) {
      URL.revokeObjectURL(cropImageSrc);
    }
    setCropModalVisible(false);
    setCropImageSrc("");
    setCropOriginalFile(null);
  };

  const finishCrop = (nextFile) => {
    cropResolveRef.current?.resolve(nextFile);
    cropResolveRef.current = null;
    closeCropModal();
  };

  const cancelCrop = () => {
    cropResolveRef.current?.reject(Upload.LIST_IGNORE);
    cropResolveRef.current = null;
    closeCropModal();
  };

  function beforeUploadAccusedPhoto(file) {
    return beforeUpload(file).then(() => {
      return new Promise((resolve, reject) => {
        cropResolveRef.current = { resolve, reject };
        setCropOriginalFile(file);
        setCropImageSrc(URL.createObjectURL(file));
        setCropModalVisible(true);
      });
    });
  }

  const uploadImage = (options) => {
    const { onSuccess, onError, file, onProgress } = options;

    // var file1 = {
    //   ...file,
    //   name:props.otherInformationData[0].masterId +'-'+ file.name
    // }

    new Compressor(file, {
      quality: 0.2,
      async success(result) {
        const fmData = new FormData();
        setProgress(0);
        const config = {
          headers: {
            accept: "application/json",
            "Accept-Language": "en-US,en;q=0.8",
            "Content-Type": `multipart/form-data; boundary=${fmData._boundary}`,
          },
          onUploadProgress: (event) => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            setProgress(percent);
            if (percent === 100) {
              setTimeout(() => setProgress(0), 1000);
            }
            onProgress({ percent: (event.loaded / event.total) * 100 });
          },
        };
        const newFileName = "pc_" + result.name;
        fmData.append("profileImage", result, newFileName);
        try {
          const res = await axios.post(
            baseUrl + "/imageupload/profile-img-upload",
            fmData,
            config
          );

          if (res.data && res.data.error) {
            onError({ ...res.data.error });
          } else {
            SetfileList([
              ...fileList,
              {
                uid: res.data.imageName || `${Date.now()}`,
                name: res.data.imageName,
                status: "done",
                url:
                  process.env.REACT_APP_PROFILE_IMAGE_BUCKET_URL +
                  res.data.imageName,
              },
            ]);
            setIsImageUploaded(true);

            onSuccess("Ok");
          }
        } catch (err) {
          const error = new Error("Some error");
          onError({ err });
        }
      },
      error(err) {
        console.log(err.message);
      },
    });
  };
  function beforePdfUpload(file) {
    return new Promise((resolve, reject) => {
      const isPdfType = file.type === "application/pdf";

      if (!isPdfType) {
        message.error("Please upload only PDF file!");
        return reject(false);
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("PDF size larger than 2MB!");
        return reject(false);
      }

      // ✅ Correct Magic number validation for PDF
      const reader = new FileReader();
      reader.onloadend = function (e) {
        const arr = new Uint8Array(e.target.result).subarray(0, 4);
        let header = "";

        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }

        const isPDF = header === "25504446";

        if (!isPDF) {
          message.error("Invalid PDF file! Possible malicious file.");
          return reject(false);
        }

        resolve(true);
      };

      reader.readAsArrayBuffer(file.slice(0, 4));
    });
  }

  const phamImageUploadImage = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    const fmData = new FormData();
    setProgress(0);
    const config = {
      headers: {
        accept: "application/json",
        "Accept-Language": "en-US,en;q=0.8",
        "Content-Type": `multipart/form-data; boundary=${fmData._boundary}`,
      },
      onUploadProgress: (event) => {
        const percent = Math.floor((event.loaded / event.total) * 100);
        setProgress(percent);
        if (percent === 100) {
          setTimeout(() => setProgress(0), 1000);
        }
        onProgress({ percent: (event.loaded / event.total) * 100 });
      },
    };
    const newFileName = "pc_" + file.name;
    fmData.append("profileImage", file, newFileName);

    try {
      const res = await axios.post(
        baseUrl + "/imageupload/profile-img-upload",
        fmData,
        config
      );

      if (res.data && res.data.error) {
        onError({ ...res.data.error });
      } else {
        // SetImageList_2([
        //   ...imageList_2,res.data.imageName
        // ])
        SetphamfileList([
          ...phamfileList,
          {
            uid: "1",
            name: res.data.imageName,
            status: "done",
            url: process.env.REACT_APP_PROFILE_IMAGE_BUCKET_URL,
          },
        ]);
        onSuccess("Ok");
      }
    } catch (err) {
      const error = new Error("Some error");
      onError({ err });
    }
  };

  const tapshilsfilUploadImage = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    const fmData = new FormData();
    setProgress(0);
    const config = {
      headers: {
        accept: "application/json",
        "Accept-Language": "en-US,en;q=0.8",
        "Content-Type": `multipart/form-data; boundary=${fmData._boundary}`,
      },
      onUploadProgress: (event) => {
        const percent = Math.floor((event.loaded / event.total) * 100);
        setProgress(percent);
        if (percent === 100) {
          setTimeout(() => setProgress(0), 1000);
        }
        onProgress({ percent: (event.loaded / event.total) * 100 });
      },
    };
    fmData.append("document", file, file.name);
    try {
      const res = await axios.post(
        baseUrl + "/document/documentUpload",
        fmData,
        config
      );

      if (res.data && res.data.error) {
        onError({ ...res.data.error });
      } else {
        // SetDocList_1([
        //   ...docList_1,res.data.imageName
        // ])
        Settapshilsfile([
          ...tapshilsfile,
          {
            uid: "1",
            name: res.data.imageName,
            status: "done",
            url: process.env.REACT_APP_PROFILE_IMAGE_BUCKET_URL,
          },
        ]);
        onSuccess("Ok");
      }

      //  //console.log("server res: ", res);
      // if(res){
      //   SetDocList_1([
      //     ...docList_1,res.data.filename
      //   ])
      // }
    } catch (err) {
      //console.log("Eroor: ", err);
      const error = new Error("Some error");
      onError({ err });
    }
  };

  useImperativeHandle(ref, () => ({
    onFinish() {
      form.submit();
    },
  }));
  console.log("values", values);
  useEffect(
    (res) => {
      if (
        props.otherInformationData &&
        props.otherInformationData.length &&
        props.isEditForms
      ) {
        // setInputField(props.basicInformationData[0]);

        const length = props.otherInformationData.length - 1;
        console.log("length", length);
        console.log("props.otherInformationData", props.otherInformationData);

        form.setFieldsValue({
          ...props.otherInformationData[length],
          accusedCourtDate: props.otherInformationData[length].accusedCourtDate
            ? moment(props.otherInformationData[length].accusedCourtDate)
            : moment(),
        });

        SetfileList([]);

        // IMAGE UPDATE ACCUSED IMAGE

        const Images = props.otherInformationData?.[length]?.accusedImage;
        console.log("Images", Images);

        let accusedImageTemp = [];
        if (Images) {
          if (typeof Images === "string") {
            accusedImageTemp = Images.includes(",")
              ? Images?.split(",")
              : [Images];
          } else if (Array.isArray(Images)) {
            accusedImageTemp = Images;
          }
        }
        console.log("accusedImageTemp", accusedImageTemp);
        let accusedImage =
          accusedImageTemp &&
          accusedImageTemp?.length &&
          accusedImageTemp?.map((item, index) => {
            // SetImageList_1([
            //   ...imageList_1,
            //   item
            // ])
            return {
              uid: index,
              name: item,
              status: "done",
              url: process.env.REACT_APP_PROFILE_IMAGE_BUCKET_URL + item,
            };
          });

        const Images1 = props.otherInformationData?.[length]?.accusedPham;
        console.log("Images", Images);

        let accusedPhamTemp = [];
        if (Images) {
          if (typeof Images1 === "string") {
            accusedPhamTemp = Images1.includes(",")
              ? Images?.split(",")
              : [Images1];
          } else if (Array.isArray(Images1)) {
            accusedPhamTemp = Images1;
          }
        }

        // let accusedPhamTemp =
        //   props.otherInformationData[length]?.accusedPham &&
        //   props.otherInformationData[length]?.accusedPham.length
        //     ? props.otherInformationData[length]?.accusedPham?.split(",")
        //     : [];
        let accusedPham =
          accusedPhamTemp &&
          accusedPhamTemp?.length &&
          accusedPhamTemp.map((item, index) => {
            // SetImageList_2([
            //   ...imageList_2,
            //   item
            // ])
            return {
              uid: index,
              name: item,
              status: "done",
              url: process.env.REACT_APP_PROFILE_IMAGE_BUCKET_URL + item,
            };
          });

        let accusedRecordsTemp =
          props.otherInformationData[length].accusedRecords &&
          props.otherInformationData[length].accusedRecords.length
            ? props.otherInformationData[length].accusedRecords.split(",")
            : [];
        let accusedRecords =
          accusedRecordsTemp &&
          accusedRecordsTemp.length &&
          accusedRecordsTemp.map((item, index) => {
            // SetImageList_2([
            //   ...imageList_2,
            //   item
            // ])
            return {
              uid: index,
              name: item,
              status: "done",
              url: process.env.REACT_APP_PROFILE_IMAGE_BUCKET_URL + item,
            };
          });
        let registered_criminal_cases = props.otherInformationData[length]
          ?.registered_criminal_cases
          ? props.otherInformationData[length]?.registered_criminal_cases
          : [];
        SetfileList(accusedImage && accusedImage ? accusedImage : []);
        SetphamfileList(accusedPham && accusedPham ? accusedPham : []);
        Settapshilsfile(accusedRecords && accusedRecords ? accusedRecords : []);
        SetNewMemberList(registered_criminal_cases);
      }
    },
    [
      props.otherInformationData[props.otherInformationData.length - 1] &&
        props.isEditForms,
    ]
  );
  console.log(
    "Last element:",
    props.otherInformationData[props.otherInformationData.length - 1]
  );

  const [newMemberList, SetNewMemberList] = useState([]);
  const onaccusedCourtCaseChange = (e) => {
    if (e.target.value) {
      SetIsMemberTxt(true);
    } else {
      SetIsMemberTxt(null);
    }
  };
  const onDeleteMembers = (values) => {
    if (values) {
      let tempMember = newMemberList;
      let getIndex = _.findIndex(newMemberList, values);
      let temp = tempMember.splice(getIndex, 1);

      setTimeout(() => {
        SetNewMemberList([]);
        SetNewMemberList(tempMember);
      }, 100);
    }
  };
  const addNewMemberName = () => {
    let ob = {
      case_no: form.getFieldValue().case_no,
    };
    SetNewMemberList([
      ...newMemberList,
      {
        ...ob,
      },
    ]);
    form.resetFields(["case_no"]);
    SetIsMemberTxt();
  };
  console.log("new member list", newMemberList);

  return (
    <div>
      <Form layout="vertical" hideRequiredMark onFinish={onFinish} form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="isMemberOfGang"
              label={t("is_gang_member")}
              rules={[{ message: "Please select value" }]}
            >
              <Select placeholder="Please select value">
                <Option value="होय">होय</Option>
                <Option value="नाही">नाही</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="accusedBusiness"
              label={t("accused_occupation_income_source")}
              rules={[{ message: "Please enter value" }]}
            >
              <Input
                onKeyPress={(e) => {
                  if (!/[A-Za-z\u0900-\u097F\s]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                placeholder="Please enter value"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="accusedFamilyMember"
              label={t("accused_family_member")}
              rules={[{ message: "Please enter value" }]}
            >
              <Input
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onPaste={(event) => {
                  event.preventDefault();
                }}
                placeholder="Please enter value"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="accusedAssets"
              label={t("accused_family_member")}
              rules={[{ message: "Please enter value" }]}
            >
              <Input
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onPaste={(event) => {
                  event.preventDefault();
                }}
                placeholder="Please enter value"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="accusedResidence"
              label={t("accused_location_lat_long")}
              rules={[{ message: "Please enter value" }]}
            >
              <Input placeholder="Please enter value" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              name="accusedJurisdiction"
              label={t("accused_crime_area")}
              rules={[{ message: "Please enter value" }]}
            >
              <Input
                onKeyPress={(e) => {
                  if (!/[A-Za-z\u0900-\u097F\s]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                placeholder="Please enter value"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="case_no"
              label={t("court_case_number")}
              rules={[{ message: "Please enter value" }]}
            >
              <Input
                placeholder="Please enter value"
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onPaste={(event) => {
                  event.preventDefault();
                }}
                onChange={onaccusedCourtCaseChange}
              />
            </Form.Item>
          </Col>
          <Col span={2}>
            <Button
              style={{ marginTop: "30px" }}
              type="button"
              disabled={!isMemberTxt}
              onClick={addNewMemberName}
              title={t("add_more")}
            >
              <PlusOutlined />
            </Button>
          </Col>
          <Col span={8}>
            <Form.Item
              name="accusedCourtDate"
              label={t("court_dates_of_accused")}
            >
              <DatePicker inputReadOnly />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={24}>
            {newMemberList && newMemberList.length ? (
              <CriminalcourtcasesTable
                data={newMemberList}
                onDeleteMembers={onDeleteMembers}
              ></CriminalcourtcasesTable>
            ) : null}
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              name="accusedjailStatus"
              label={t("accused_current_status")}
              rules={[{ message: "Please enter value" }]}
            >
              <Input
                onKeyPress={(e) => {
                  if (!/[A-Za-z\u0900-\u097F\s]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                placeholder="Please enter value"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="accusedVehicalDetails"
              label={t("accused_vehicles_rto_numbers")}
              rules={[{ message: "Please enter value" }]}
            >
              <Input
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                placeholder="Please enter value"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              name="accusedLawyerDetails"
              label={t("accused_lawyer_details")}
              rules={[
                {
                  message: "please enter address",
                },
              ]}
            >
              <Input.TextArea
                onKeyPress={(e) => {
                  if (!/[A-Za-z\u0900-\u097F0-9\s]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                rows={4}
                placeholder="please enter address"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              name="accusedIdentifyingOfficer"
              label={t("officers_identifying_accused")}
              rules={[
                {
                  message: "please enter values",
                },
              ]}
            >
              <Input.TextArea
                onKeyPress={(e) => {
                  if (!/[A-Za-z\u0900-\u097F0-9\s]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                rows={4}
                placeholder="please enter values"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="accusedSupportingleaders"
              label={t("supporting_leaders_organizations")}
              rules={[
                {
                  message: "please enter values",
                },
              ]}
            >
              <Input.TextArea
                onKeyPress={(e) => {
                  if (!/[A-Za-z\u0900-\u097F0-9\s]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                rows={4}
                placeholder="please enter values"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Row gutter={24}>
        <Col span={6} style={{ marginBottom: "30px" }}>
          <Upload
            accept="image/*"
            listType="picture"
            customRequest={uploadImage}
            fileList={fileList}
            onChange={handleUpload}
            beforeUpload={beforeUploadAccusedPhoto}
            onPreview={handlePreviewAccusedImage}
            onRemove={handleRemoveAccusedImage}
            maxCount={5}
          >
            <Button icon={<UploadOutlined />}>{t("accused_photos")}</Button>
          </Upload>
          <AccusedImageCropModal
            visible={cropModalVisible}
            imageSrc={cropImageSrc}
            fileName={cropOriginalFile?.name}
            mimeType={cropOriginalFile?.type}
            onCancel={cancelCrop}
            onApply={finishCrop}
            onUseOriginal={() => finishCrop(cropOriginalFile)}
          />
          <ImageViewOnly
            imageOpen={previewOpen}
            imageUrl={previewUrl}
            onClose={() => {
              setPreviewOpen(false);
              setPreviewUrl("");
            }}
          />
        </Col>
        <Col span={6} style={{ marginBottom: "30px" }}>
          <Upload
            accept="image/*"
            customRequest={phamImageUploadImage}
            onRemove={handleRemoveAccusedPham}
            beforeUpload={beforeUpload}
            fileList={phamfileList}
            maxCount={2}
          >
            <Button icon={<UploadOutlined />}>{t("two_handprints")}</Button>
          </Upload>
        </Col>
        <Col span={12} style={{ marginBottom: "30px" }}>
          <Upload
            accept="application/pdf"
            customRequest={tapshilsfilUploadImage}
            fileList={tapshilsfile}
            onRemove={handleRemoveAccusedRecords}
            onPreview={handlePreviewAccusedRecords}
            beforeUpload={beforePdfUpload}
            maxCount={2}
          >
            <Button icon={<UploadOutlined />}>
              {t("professional_accused_details")}
            </Button>
          </Upload>
        </Col>
      </Row>
    </div>
  );
});
